import styled from 'styled-components'

export const Body = styled.div`
  box-sizing: border-box;
  overflow-y: visible;
  padding: 12px;
`

export const Title = styled.p`
  font-weight: var(--font-weight-semibold);
  font-size: 18px;
  line-height: 19px;
  color: var(--color-action-default);
  margin: 8px 0px 12px 0px;
  padding: 0px 10px;
`
export const Text = styled.p`
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-contrast-brand);
  margin-top: 12px 0px 0px 0px;
  padding: 4px 0px;
`

export const StyledMultiSelect = styled.div`
  padding: 5px 0px 32px 0px;
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;

  .primary-btn-text {
    color: white !important;
  }
`
